import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, message, Modal, Select, Spin, UploadFile } from "antd";
import React, { useEffect, useState } from "react";
import UserSystemForm from "./UserSystemForm";
import {
  useCreateUserSystem,
  useGetUserRoleWithoutAdmin,
  useUpdateUserSystem,
} from "hooks/useAuth";
import { UserSystemData } from "services/interface";

const { Option } = Select;

interface ModalAddUserProps {
  editData: UserSystemData | undefined;
  isShow: boolean;
  onClose: () => void;
}

const ModalEditUser = ({ editData, isShow, onClose }: ModalAddUserProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useUpdateUserSystem();

  const [showModal, setShowModal] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const { data: roleUserWithoutAdmin, isLoading: roleUserWithoutAdminLoading } =
    useGetUserRoleWithoutAdmin();

  useEffect(() => {
    if (editData) {
      let role_id = "";
      // eslint-disable-next-line array-callback-return
      roleUserWithoutAdmin?.data.find((role) => {
        if (role.role_key === editData.role_permission) {
          role_id = role.id;
        }
      });

            const main_images_item: UploadFile[] =  editData.image ? [{
              uid: editData.image,
              name: "image.png",
              status: "done",
              url: editData.image,
            }] : [];
          

      formModal.setFieldsValue({
        first_name: editData.first_name,
        last_name: editData.last_name,
        email: editData.email,
        mobile: editData.mobile,
        image:main_images_item,
        role_id: editData.role_user_id,
        is_generated_password: false,
        is_otp: true,
        line_1: editData.line_1,
        line_2: "",
        province: editData.province_id,
        district: editData.district_id,
        sub_district: editData.sub_district_id,
        zip_code: editData.post_code,
        username: editData.username,
      });
    }
  }, [editData, formModal, roleUserWithoutAdmin, isShow]);

  const onCloseModal = () => {
    setShowModal(false);
    formModal.resetFields();
  };

  const onFinishModal = (values: any) => {
    console.log(values);
    mutate(
      {
        user_id: editData?.user_id || "",
        first_name: values.first_name ? values.first_name.trim() : "",
        last_name: values.last_name ? values.last_name.trim() : "",
        email: values.email ? values.email.trim() : "",
        username: values.username ? values.username.trim() : "",
        mobile: values.mobile ? values.mobile.trim() : "",
        image: values.image && values.image.length > 0 ? values.image[0].url : "",
        role_id: values.role_id,
        is_generated_password: false,
        is_otp: true,
        address: {
          line_1: values.line_1 ? values.line_1.trim() : "",
          line_2: "",
          province_id: values.province,
          district_id: values.district,
          sub_district_id: values.sub_district,
          post_code: values.zip_code,
        },
      },
      {
        onSuccess: async (data) => {
          if (!data.error_message) {
            await queryClient.refetchQueries({
              queryKey: ["user_system"],
              type: "active",
            });
            onCloseModal();
            onClose();
            message.success("แก้ไขผู้ใช้งานระบบสำเร็จ");
          } else {
            message.error(`แก้ไขผู้ใช้งานระบบไม่สำเร็จ: ${data.error_message}`);
          }
        },
      }
    );
  };

  return (
    <div>
      <Modal
        title="แก้ไขผู้ใช้งานระบบ"
        open={isShow}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        width={800}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          {roleUserWithoutAdminLoading ? (
            <Spin size="large" />
          ) : (
            <UserSystemForm
              form={formModal}
              onFinish={onFinishModal}
              isPending={isPending}
              editData={editData}
            />
          )}
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalEditUser;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
